<template>
  <InputSelect
    :disabled="props.disabled"
    :error-fields="errorFields"
    :model-value="modelValue"
    :name="name"
    :options="products"
    :submitted="submitted"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    Prodotto
  </InputSelect>
</template>

<script setup>
import useAxios from "@/composables/axios";

import InputSelect from './InputSelect.vue';

const props = defineProps({
  errorFields: {
    type: Object,
    required: true
  },
  submitted: {
    type: Boolean,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  modelValue: {
    type: String,
    default: null
  },
  categoryUuid: {
    type: String,
    default: null
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

defineEmits(['update:modelValue'])

const axios = useAxios()

const productResp = await axios.get('/product/list')
const products = productResp.data.filter((product) => {
  if(props.categoryUuid) {
    return props.categoryUuid === product.categoryUuid;
  }
  return true;
}).map((product) => {
  return {
    id: product.uuid,
    label: product.code
  }
})

</script>